import { useImpersonation } from '../../hooks/useImpersonation';

export default function ImpersonationBanner() {
  const { isImpersonating, targetUser, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !targetUser) {
    return null;
  }

  return (
    <div className="bg-amber-500 text-white px-4 py-2 text-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <span>
            Viewing as <strong>{targetUser.email}</strong>
            {targetUser.organization_name && (
              <span className="opacity-90"> ({targetUser.organization_name})</span>
            )}
          </span>
        </div>
        <button
          onClick={stopImpersonation}
          className="px-3 py-1 bg-white/20 hover:bg-white/30 rounded text-sm font-medium transition-colors"
        >
          Exit
        </button>
      </div>
    </div>
  );
}
